(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/upcoming-events/assets/javascripts/tournament-type-filter.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/upcoming-events/assets/javascripts/tournament-type-filter.js');
"use strict";

var _svs$poker_react$data;

const _svs$ui$reactForm = svs.ui.reactForm,
  RadioGroup = _svs$ui$reactForm.RadioGroup,
  RadioButton = _svs$ui$reactForm.RadioButton;
const TournamentFilters = svs.poker_react.components.common.constants.TournamentFilters;
let renderFilters;
if (!((_svs$poker_react$data = svs.poker_react.data.upcomingEventsData) !== null && _svs$poker_react$data !== void 0 && _svs$poker_react$data.pokerSMVisible)) {
  renderFilters = TournamentFilters.filter(gameType => gameType.id !== 'poker-sm');
} else {
  renderFilters = TournamentFilters.filter(gameType => gameType.id !== 'poy');
}
const TournamentTypeFilter = _ref => {
  let activeTournamentFilter = _ref.activeTournamentFilter,
    setTournamentFilter = _ref.setTournamentFilter;
  return React.createElement(RadioGroup, {
    className: "filter-btn-container",
    size: 200
  }, renderFilters.map(filter => React.createElement(RadioButton, {
    aria: filter.id === 'poy' ? {
      label: 'Player of the year'
    } : undefined,
    branding: "poker-react",
    checked: filter.id === activeTournamentFilter,
    key: filter.id,
    onChange: () => setTournamentFilter(filter),
    value: filter.id
  }, filter.title)));
};
setGlobal('svs.poker_react.components.upcomingEvents.TournamentTypeFilter', TournamentTypeFilter);

 })(window);